import { useState, useEffect, useCallback } from 'react';
import BackgroundCanvasProcessorPresets from './BackgroundCanvasProcessorPresets';

export default function PreviewBatchGeneratorPresets({ pages, selectedLanguage, onAllDone, onError }) {
  const [index, setIndex] = useState(0);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    if (!failed && index >= pages.length) onAllDone?.();
  }, [failed, index, pages.length, onAllDone]);
  const currentPage = pages[index];
  const handleDone = useCallback((result) => {
    if (!result?.success) {
      setFailed(true);
      onError?.(`Page ${currentPage?.page_number || result?.pageId}: ${result?.error || result?.fatalError || 'Generation failed'}`);
      return;
    }
    setIndex((current) => current + 1);
  }, [currentPage?.page_number, onError]);
  return <>
    <p>Processing page {Math.min(index + 1, pages.length)}/{pages.length}…</p>
    {!failed && currentPage && <BackgroundCanvasProcessorPresets key={currentPage._id}
      pageId={currentPage._id} selectedLanguage={selectedLanguage} onDone={handleDone} />}
  </>;
}
